import { Routes } from '@angular/router';
import { authGuard } from './shared/auth-guard';
import { Layout } from './layout/layout/layout';
import { SignIn } from './feature/auth/sign-in/sign-in';
import { otpGuard } from './shared/otp-guard';
import { Payment } from './feature/payment/payment';

export const routes: Routes = [
  {
    path: 'sign-in',
    component: SignIn,
  },
  {
    path: 'payment',
    component: Payment,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'sign-in',
  },
  {
    path: '',
    canActivate: [authGuard, otpGuard],
    component: Layout,
    children: [
      {
        path: 'member_ledger',
        loadChildren: () =>
          import('./feature/memberLedgerView/memberLedger.route').then((m) => m.MemberLedgerRoute),
      },
      {
        path: 'member_ledger',
        loadChildren: () =>
          import('./feature/memberLedgerView/memberLedger.route').then((m) => m.MemberLedgerRoute),
      },
      {
        path: 'month_bill',
        loadChildren: () =>
          import('./feature/monthBill/monthBill.route').then((m) => m.MonthBillRoute),
      },
      {
        path: 'enach',
        loadChildren: () =>
          import('./feature/enach/enach.route').then((m) => m.EnachRoute),
      },
      {
        path: 'transaction_history',
        loadChildren: () =>
          import('./feature/transactionHistory/transactionhistory.route').then((m) => m.TransactionHistoryRoute),
      },
      {
        path: 'site_policy',
        loadChildren: () =>
          import('./feature/sitePolicy/sitepolicy.route').then((m) => m.SitePolicyRoute),
      },
      {
        path: 'affiliated_club',
        loadChildren: () =>
          import('./feature/affiliatedClub/affiliatedclub.route').then((m) => m.AffiliatedClubRoute),
      },
      {
        path: 'club_facility',
        loadChildren: () =>
          import('./feature/clubFacility/clubfacility.route').then((m) => m.ClubFacilityRoute),
      },
      {
        path: 'contact_office',
        loadChildren: () =>
          import('./feature/officeContacts/officecontacts.route').then((m) => m.OfficeContactsRoute),
      },
      {
        path: 'kga-website',
        loadChildren: () =>
          import('./feature/kga-website/kga-website.route').then((m) => m.KgaweBsiteRoute),
      },
      {
        path: 'sitr-url',
        loadChildren: () =>
          import('./feature/policy/site-policy.route').then((m) => m.sitepolicyhomeRoute),
      },
      {
        path: 'member_directory',
        loadChildren: () =>
          import('./feature/memberDirectory/memberDirectory.route').then((m) => m.MemberDirectoryRoute)
      },
      {
        path: 'payment',
        loadChildren: () =>
          import('./feature/payment-folder/payment-success.route').then((m) => m.PaymentSuccessRoute)
      },
      {
        path: 'monthly_bill',
        loadChildren: () =>
          import('./feature/monthlyBill/monthlybill.route').then((m) => m.MonthlyBillRoute)
      },
      {
        path: 'receipt',
        loadChildren: () =>
          import('./feature/receipt/receipt.route').then((m) => m.ReceiptRoute)
      }
    ],
  },

];
